







































































































import { Component, Vue } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Ajax from "../../lib/ajax";
import CreateTicket from "./create-ticket.vue";
import EditTicket from "./edit-ticket.vue";
import TicketDetail from "./ticket-detail.vue";
class PageticketRequest extends PageRequest {
  name: string;
  showOnHome: boolean;
  courtId: number | null = null;
  isBack: boolean = true;
}

@Component({
  components: { EditTicket, CreateTicket, TicketDetail },
})
export default class tickets extends AbpBase {
  // 编辑按钮事件处理
  edit() {
    this.editModalShow = true;
  }
  //请求过滤参数
  pagerequest: PageticketRequest = new PageticketRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;
  ticketId: number = null;
  courtList: any = [];
  detailShow: boolean = false;
  ticketList: Array<any> = [
    {
      value: "true",
      label: "是",
    },
    {
      value: "false",
      label: "否",
    },
  ];

  get list() {
    return this.$store.state.ticket.list;
  }
  get loading() {
    return this.$store.state.ticket.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("ticket/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("ticket/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("ticket/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "ticket/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.ticket.pageSize;
  }
  get totalCount() {
    return this.$store.state.ticket.totalCount;
  }
  get currentPage() {
    return this.$store.state.ticket.currentPage;
  }
  async getCourtList() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
  }
  updateDisplayOrder(row) {
    Ajax.put("/api/services/app/ticket/UpdateticketDisplayOrder", {
      id: row.id,
      displayOrder: row.displayOrder,
    });
  }

  async changeActive(row, pass: boolean) {
    this.$store.commit("ticket/changeLoading", true);
    await Ajax.put("/api/services/app/ticket/UpdateticketActiveState", {
      id: row.id,
      isActive: pass,
    });
    await this.getpage();
    this.$store.commit("ticket/changeLoading", false);
  }
  async changePreferential(row, pass: boolean) {
    this.$store.commit("ticket/changeLoading", true);
    await Ajax.put("/api/services/app/ticket/UpdateticketPreferential", {
      id: row.id,
      isPreferential: pass,
    });
    await this.getpage();
    this.$store.commit("ticket/changeLoading", false);
  }
  columns = [
    {
      title: "名称",
      key: "name",
      tooltip: true,
    },
    {
      title: "价格",
      key: "price",
    },
    {
      title: "供应商",
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.supplier && params.row.supplier.name
            ? params.row.supplier.name
            : "暂无"
        );
      },
    },
    {
      title: "是否首页显示",
      key: "showOnHome",
      render: (h: any, params: any) => {
        return h("span", params.row.showOnHome == true ? "是" : "否");
      },
    },
    {
      title: "开始日期",
      key: "startTime",
      tooltip: true,
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.startTime).toLocaleDateString());
      },
    },
    {
      title: "结束日期",
      key: "endTime",
      tooltip: true,
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.endTime).toLocaleDateString());
      },
    },
    {
      title: "倒计时天数",
      render: (h: any, params: any) => {
        return h("span", params.row.endDay + "天");
      },
    },
    // {
    //   title: "产品说明",
    //   key: "description",
    //   tooltip: true,
    // },
    // {
    //   title: "使用流程",
    //   key: "flow",
    //   tooltip: true,
    // },
    // {
    //   title: "使用规则",
    //   key: "useRole",
    //   tooltip: true,
    // },
    {
      title: "显示顺序",
      key: "displayOrder",
      tooltip: true,
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 200,
      align: "center",
      slot: "action",
      render: (h: any, params: any) => {
        const hasEditPermission = this.hasPermission("Pages.Ticket.Edit");
        const hasDeletePermission = this.hasPermission("Pages.Ticket.Delete");
        const buttons = [];
        if (hasEditPermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    this.ticketId = params.row.id;
                    this.$store.commit("ticket/edit", params.row);
                    this.edit();
                  },
                },
              },
              "编辑"
            )
          );
        }
        if (hasDeletePermission) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: this.L("Tips"),
                      content: "确定要删除该套票吗",
                      okText: this.L("Yes"),
                      cancelText: this.L("No"),
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "ticket/delete",
                          data: params.row,
                        });
                        await this.getpage();
                      },
                    });
                  },
                },
              },
              "删除"
            )
          );
        }
        buttons.push(
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginLeft: "5px",
              },
              on: {
                click: async () => {
                  console.log('ppp')
                  this.openDetail(params.row);
                },
              },
            },
            "详情"
          )
        );
        return h("div", buttons);
      },
    },
  ];
  /**
   * @description:打开弹窗查看详情信息
   */
  openDetail(ticket) {
    console.log(ticket,'ticket')
    this.ticketId = ticket.id;
    this.detailShow = true;
    console.log(this.detailShow,'detailShow');
  }
  async created() {
    this.getCourtList();
    this.getpage();
  }
}
